/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 16:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  searchForTheAttributeRuleName: '搜索属性规则名称',
  attributeRules: '属性规则',
  rulesName: '规则名称',
  propertiesFile: '属性文件',
  ruleBreakdown: '规则明细',
  propertiesFileField: '属性文件字段',
  propertyTemplateCode: '属性模板代码',
  thePropertyTemplateName: '属性模板名称',
  propertyCode: '属性代码',
  propertyName: '属性名称',
  attributeCategory: '属性类别',
  addedAttributeRules: '新增属性规则',
  editTheAttributeRule: '编辑属性规则',
  addedAttributeRuleDetails: '新增属性规则明细',
  editTheAttributeRuleDetails: '编辑属性规则明细',
  pleaseFillInThisField: '请填写该字段',
  pleaseSelectTheDataYouWantToDelete: '请选择要删除的数据',
  whetherToDeleteTheData: '是否删除该项数据',
  deletionSuccessful: '删除成功！',
  pleaseSelectThePropertyTemplateCode: '请选择属性模板代码！',
  pleaseSelectAPropertyCode: '请选择属性代码！',
  thAttributeRuleHasNotBeenSelected: '尚未选择属性规则',
}
